import React from "react";

const WatchLater = () => <p>WatchLater</p>;

export default WatchLater;
